import { useEffect, useState } from 'react';
import yaml from 'js-yaml';

export default function useYamlData(path, initialValue = null) {
  const [data, setData] = useState(initialValue);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isCurrent = true;

    async function load() {
      try {
        const response = await fetch(path);
        if (!response.ok) throw new Error(`Unable to load ${path}`);
        const parsedData = yaml.load(await response.text());
        if (isCurrent) setData(parsedData);
      } catch (loadError) {
        if (isCurrent) setError(loadError.message);
      } finally {
        if (isCurrent) setLoading(false);
      }
    }

    load();
    return () => { isCurrent = false; };
  }, [path]);

  return { data, loading, error };
}